import { inject, Injectable } from '@angular/core';
import { CommonConstants } from '@app/common-constants';
import { LoggerService } from '@app/services/logger.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import {
  checkUserActive,
  recordUserActivity,
  SessionManagementFacade,
  setUserActive,
  setUserActivityRecorded,
  userLoginComplete,
} from '@ra-state';
import { from, fromEvent, Observable, timer } from 'rxjs';
import { mergeMap, switchMap, take, tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class SessionManagementEffects {
  private readonly actions$ = inject(Actions);
  private readonly sessionManagementFacade = inject(SessionManagementFacade);
  logger = inject(LoggerService).withContext(SessionManagementEffects);

  getTimer: () => Observable<number>;

  loginCompleted$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType(userLoginComplete),
      tap(() => this.generateTimer()),
      switchMap(() => {
        return [recordUserActivity(), checkUserActive()];
      }),
    );
  });

  recordUserActivity$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType(recordUserActivity),
      switchMap(() => from(['keydown', 'click', 'wheel', 'mousemove'])),
      mergeMap((event) => fromEvent(document, event).pipe(take(1))),
      concatLatestFrom(() => [this.sessionManagementFacade.userActive$]),
      switchMap(() => {
        return [setUserActivityRecorded({ value: true })];
      }),
    );
  });

  defaultTimer = (): Observable<number> => {
    return timer(CommonConstants.userActivityIntervalMillis, CommonConstants.userActivityIntervalMillis);
  };

  generateTimer(getTimer = this.defaultTimer): void {
    this.getTimer = getTimer;
  }

  checkUserActive$ = createEffect((): Observable<any> => {
    return this.actions$.pipe(
      ofType(checkUserActive),
      switchMap(() => this.getTimer()),
      concatLatestFrom(() => [this.sessionManagementFacade.userActivityRecorded$]),
      switchMap(([timer, _userActive]) => {
        return [setUserActive({ value: timer > 0 }), setUserActivityRecorded({ value: false })];
      }),
    );
  });
}
